import { EnvUsersPage } from "@/features/users/env-users-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/users")({
  component: EnvUsersPage,
});
